import { createSlice } from "@reduxjs/toolkit";
import { storageSave, storageDelete } from "../../utils/localStorage";

const authSlice = createSlice({
	name: "auth",
	initialState: {
		token: null,
		refresh: null,
		userDetails: null,
		organizationName: null,
		childOrganizationName: null,
		selectedOrganization: null,
		organizationId: null,
		organizationByInternalUser: null,
		organizationIdByInternalUser: null,
		loEmail: null,
		lpEmail: null,
	},
	reducers: {
		setCredentials: (state, action) => {
			console.log("15 action:", action);

			const {
				access,
				refresh,
				username,
				email,
				first_name,
				last_name,
				user_roles,
				organization_name,
				organization_id,
				child_org_name,
			} = action.payload;

			console.log("30 organization_name:", organization_name);
			console.log("30 child_org_name:", child_org_name);

			state.token = access;
			state.refresh = refresh;
			state.organizationName = organization_name;
			state.organizationId = organization_id;
			state.childOrganizationName = child_org_name;

			state.userDetails = {
				username,
				email,
				first_name,
				last_name,
				user_roles,
			};
			if (refresh !== undefined) {
				storageSave("access-token", access);
				storageSave("refresh-token", refresh);
			}
		},
		logOut: (state, action) => {
			state.token = null;
			state.refresh = null;
			state.userDetails = null;
			state.organizationName = null;
			state.organizationByInternalUser = null;
			state.organizationIdByInternalUser = null;
			state.organizationId = null;
			state.childOrganizationName = null;
			state.selectedOrganization = null;
			localStorage.clear();
			state = null;
		},
		setUserDetails: (state, action) => {
			state.userDetails = action.payload;
		},
		setUsername: (state, action) => {
			state.username = action.payload;
		},
		setOrganizationName: (state, action) => {
			state.organizationName = action.payload;
		},
		setChildOrganizationName: (state, action) => {
			state.childOrganizationName = action.payload;
		},
		setLoEmail: (state, action) => {
			state.loEmail = action.payload;
		},
		setLpEmail: (state, action) => {
			state.lpEmail = action.payload;
		},
		setAccessToken: (state, action) => {
			state.token = action.payload;
		},
		setRefreshToken: (state, action) => {
			state.refresh = action.payload;
		},
		setOrganizationId: (state, action) => {
			state.organizationId = action.payload;	
		},
		setSelectedOrganization: (state, action) => {
			const orgDetails = action.payload;

			if (!orgDetails || typeof orgDetails !== "object") {
				state.selectedOrganization = null;
				state.organizationId = null;
				storageDelete("selected-organization");
				storageDelete("selected-organization-id");
				return;
			}

			state.selectedOrganization = orgDetails.name || null;
			state.organizationId = orgDetails.id || null;

			if (orgDetails.name && orgDetails.id) {
				storageSave("selected-organization", orgDetails.name);
				storageSave("selected-organization-id", orgDetails.id);
			} else {
				storageDelete("selected-organization");
				storageDelete("selected-organization-id");
			}
		},
		setOrganizationIdByInternalUser: (state, action) => {
			state.organizationIdByInternalUser = action.payload;	
		},
		setSelectedOrganizationByInternalUser: (state, action) => {
			const orgDetails = action.payload;

			if (!orgDetails || typeof orgDetails !== "object") {
				state.organizationByInternalUser = null;
				state.organizationIdByInternalUser = null;
				storageDelete("selected-organization-internal");
				storageDelete("selected-organization-id-internal");
				return;
			}

			state.organizationByInternalUser = orgDetails.name || null;
			state.organizationIdByInternalUser = orgDetails.id || null;

			if (orgDetails.name && orgDetails.id) {
				storageSave("selected-organization-internal", orgDetails.name);
				storageSave("selected-organization-id-internal", orgDetails.id);
			} else {
				storageDelete("selected-organization-internal");
				storageDelete("selected-organization-id-internal");
			}
		},
	},
});

export const {
	setCredentials,
	logOut,
	setUserDetails,
	setUsername,
	setOrganizationName,
	setChildOrganizationName,
	setLoEmail,
	setLpEmail,
	setAccessToken,
	setRefreshToken,
	setOrganizationId,
	setSelectedOrganization,
	setSelectedOrganizationByInternalUser,
	setOrganizationIdByInternalUser,
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentToken = (state) => state.auth.token;
export const selectRefreshToken = (state) => state.auth.refresh;
export const selectOrganizationName = (state) => state.auth.organizationName;
export const selectOrganizationId = (state) => state.auth.organizationId;
export const selectOrganizationByInternalUser = (state) => state.auth.organizationByInternalUser;
export const selectOrganizationIdByInternalUser = (state) => state.auth.organizationIdByInternalUser;
export const selectChildOrganizationName = (state) =>
	state.auth.childOrganizationName;
export const selectSelectedOrganization = (state) =>
	state.auth.selectedOrganization;
export const selectLoEmail = (state) => state.auth.loEmail;
export const selectLpEmail = (state) => state.auth.lpEmail;
export const selectUserDetails = (state) => state.auth.userDetails;
